export const TOGGLE_DISTRIBUTION_DETAILS_DRAWER = "TOGGLE_DISTRIBUTION_DETAILS_DRAWER";

export const TOGGLE_DISTRIBUTION_DRAWER = "TOGGLE_DISTRIBUTION_DRAWER";
